import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class ScopeGuardService implements CanActivate {
  constructor(private auth: AuthService, public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const scopes = (route.data as any).expectedScopes;
    // console.log(this.auth.userProfile)
    // console.log(`canActivate has scope: ${this.auth.userHasScopes(scopes)}`);
    if (!this.auth.userHasScopes(scopes)) {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }
}
